import { render, staticRenderFns } from "./CreateProposalFromImportModal.vue?vue&type=template&id=0a404c80&"
import script from "./CreateProposalFromImportModal.vue?vue&type=script&lang=js&"
export * from "./CreateProposalFromImportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports